import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { parseValueFromLocalizedAttribute } from '~/core/utils';

import { CommonGCGame } from '../../../../types';

import { SpecialEventContainer, SpecialEventImage } from './styles';

type Props = {
    game: CommonGCGame;
    addMargin?: boolean;
};

const SpecialEventDisplay: FC<Props> = ({ game, addMargin }) => {
    const intl = useIntl();

    return (
        <SpecialEventContainer $addMargin={addMargin}>
            {game.specialEvent?.lightLogoUrl ? (
                <SpecialEventImage
                    src={parseValueFromLocalizedAttribute(game.specialEvent.lightLogoUrl)}
                    alt={intl.formatMessage(
                        {
                            description: 'Descriptor for special event logo',
                            defaultMessage: '{specialEvent} Logo',
                        },
                        {
                            specialEvent: parseValueFromLocalizedAttribute(game.specialEvent?.name),
                        }
                    )}
                />
            ) : (
                parseValueFromLocalizedAttribute(game.specialEvent?.name)
            )}
        </SpecialEventContainer>
    );
};

export default SpecialEventDisplay;
